import { memo } from "react";
import { Row } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { getInvoiceEffectiveStatus } from "@common/helpers/accrual-source";
import { Invoice, InvoiceStatus } from "@common/types/invoice";
import { toDisplayDateOnly } from "@helpers/date";
import { PeriodLockIcon } from "@components/periodLock/PeriodLockIcon";
import { useIsEntityDateLocked } from "@components/periodLock/PeriodLockDatesProvider";

interface Props {
    row: Row<ViewTableFeatures, Invoice>;
}

export const LockCell = memo(({ row }: Props) => {
    const invoice = row.original;
    const isDateLocked = useIsEntityDateLocked(
        invoice.entityId,
        toDisplayDateOnly(invoice.dateOnly),
    );
    const isDraft = getInvoiceEffectiveStatus(invoice) === InvoiceStatus.DRAFT;

    if (!isDateLocked || isDraft) {
        return null;
    }

    return (
        <PeriodLockIcon
            label="This invoice is locked."
            testId="invoice-list-item-lock"
        />
    );
});
LockCell.displayName = "LockCell";
